import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "../../../examples/Tables/DataTable";
import data from "../../dashboard/components/Projects/data";
import useApi from "../../../components/Utils/api";
import toast from "react-hot-toast";
import Icon from "@mui/material/Icon";
import MDButton from "../../../components/MDButton";
import Papa from 'papaparse';
import PermissionControl from "../../../components/Utils/PermissionControl";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import MdrConfigurator from "./mdrConfigurator/mdrConfigurator";
import Typography from "@mui/material/Typography";

function MdrMaster() {
  const { mdrMasterTableColumns } = data();
  const [masters, setMasters] = useState([]);
  const [masterToDelete, setMasterToDelete] = useState(null);
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
  const [openConfigurator, setOpenConfigurator] = useState(false);
  const [master, setMaster] = useState({});
  const api = useApi();

  function updateMasterHandler(item) {
    setMaster(item);
    setOpenConfigurator(true);
  }

  const deleteMdrHandler = (item) => {
    setOpenPasswordDialog(true);
    setMasterToDelete(item);
  }

  const handleDeleteMdrMaster = () => {
    if (!masterToDelete) return;

    api.delete("master/mdrMaster/" + masterToDelete.mcId)
      .then(response => {
        if (response.status === 204) {
          toast.success("MDR deleted for merchant " + masterToDelete.mid);
          getMasters();
          setOpenPasswordDialog(false);
          setMasterToDelete(null);
        }
      })
      .catch(error => {
        // Handle error
      });
  }

  const getMasters = () => {
    api.post("master/getMdrMasters")
      .then((response) => {
        if (response.data.statusCodeValue === 200) {
          const modifiedData = response.data.body.map(item => {
            const action = (
              <MDBox display="flex" alignItems="center" lineHeight={1}>
                <PermissionControl permission={{ restrict: true, module: "Masters", subModule: "UpdateMdrMaster" }}>
                  <Icon fontSize="small" style={{ cursor: 'pointer' }} onClick={() => updateMasterHandler(item)}>create</Icon>
                </PermissionControl>
                <PermissionControl permission={{ restrict: true, module: "Masters", subModule: "DeleteMdrMaster" }}>
                  <Icon fontSize="small" style={{ cursor: 'pointer' }} onClick={() => deleteMdrHandler(item)}>delete</Icon>
                </PermissionControl>
              </MDBox>
            );
            return { ...item, action };
          });
          setMasters(modifiedData);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        toast.error(error.response.data.body);
      })
  }

  const generateCSV = () => {
    if (masters.length === 0) {
      return '';
    }
  
    // Filter out columns with "Action" as the header
    const filteredColumns = mdrMasterTableColumns.filter(column => column.Header !== "Action");
  
    const headers = filteredColumns.map(column => column.Header);
  
    const mastersWithUppercaseColumns = masters.map(item => {
      return filteredColumns.map(column => {
        const accessor = column.accessor;
        const value = typeof accessor === 'function' ? accessor(item) : item[accessor];
        return value;
      });
    });
  
    const csvData = [headers, ...mastersWithUppercaseColumns];
  
    const csv = Papa.unparse(csvData, {
      quotes: true,
    });
  
    return csv;
  };
  

  const handleDownloadCSV = () => {
    if (masters.length === 0) {
      toast.error("No records found to download.");
      return;
    }

    const csvData = generateCSV();

    const currentDate = new Date().toISOString().slice(0, 10);
    const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
    const dateTimeString = `${currentDate}_${currentTime}`;

    const fileName = `MdrMaster_${dateTimeString}.csv`;

    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    getMasters();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid container justifyContent="flex-end">
            <PermissionControl permission={{ restrict: true, module: "Masters", subModule: "CreateMdrMaster" }}>
              <MDButton variant="gradient" onClick={() => {
                setOpenConfigurator(true);
                setMaster({});
              }} color="info" style={{ marginBottom: "12px" }}>
                Add Merchant MDR
              </MDButton>
            </PermissionControl>
          </Grid>
          <Grid item xs={12} lg={12}>
            <MDButton
              variant="gradient"
              onClick={handleDownloadCSV}
              color="info"
              style={{ marginRight: "24px", marginBottom: "12px" }}
            >
              Export
            </MDButton>
            <DataTable
              table={{ columns: mdrMasterTableColumns, rows: masters }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              canSearch={true}
            />
          </Grid>
        </Grid>
      </MDBox>
      {/* Render MdrConfigurator component */}
      <MdrConfigurator openConfigurator={openConfigurator} setOpenConfigurator={setOpenConfigurator} master={master} getMasters={getMasters} />

      {/* Dialog for delete confirmation */}
      <Dialog
        open={openPasswordDialog}
        onClose={() => setOpenPasswordDialog(false)}
        aria-labelledby="delete-dialog-title"
      >
        <DialogTitle id="delete-dialog-title">Delete MDR Master</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the MDR for merchant <strong>{masterToDelete?.mid}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenPasswordDialog(false);
            setMasterToDelete(null);
          }}>Cancel</Button>
          <Button onClick={handleDeleteMdrMaster}>Delete</Button>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
}

export default MdrMaster;
